import { getSpecialistsInSpecialistsPageBlock } from '@/shared/api/strapi/requests/specialist/getSpecialistsInSpecialistsPageBlock'
import { getSpecialistsPageBlock } from '@/shared/api/strapi/requests/specialist/getSpecialistsPageBlock'
import { getSpecialistPageBlock } from '@/shared/api/strapi/requests/specialist/getSpecialistPageBlock'
import { getSpecialist } from '@/shared/api/strapi/requests/specialist/getSpecialist'
import { getSpecialistSeo } from '@/shared/api/strapi/requests/specialist/getSpecialistSeo'
import { getSpecialistsPageBlockSeo } from '@/shared/api/strapi/requests/specialist/getSpecialistsPageBlockSeo'

export * from './getSpecialistsInSpecialistsPageBlock'
export * from './getSpecialistsPageBlock'
export * from './getSpecialistPageBlock'
export * from './getSpecialist'
export * from './getSpecialistSeo'
export * from './getSpecialistsPageBlockSeo'

export const specialistApi = {
  getSpecialistsInSpecialistsPageBlock,
  getSpecialistsPageBlock,
  getSpecialistPageBlock,
  getSpecialist,
  getSpecialistSeo,
  getSpecialistsPageBlockSeo,
}
